import { Card } from "@mui/material";
import { MainTable } from "components";
import NoData from "components/NoData/NoData.view";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./PendingApprovalActionPlan.styles";
import { useTableOperations } from "components/MainTable/hooks/useTableOperations";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import useMyActionPlansColumns from "./useMyActionPlansColumns";
import { useNavigate } from "react-router-dom";
import { CORPORATE_BACKOFFICE_PATHS, USERTYPE } from "constants/constants";
import { ActionPlanEntity } from "entities/RCA/ActionPlanEntity/ActionPlanEntity";
import { CorporateContext } from "contexts/CorporateContext/CorporateContext";

const PendingApprovalActionPlan = () => {
    const { t } = useTranslation();
    const mainClasses = useRCAMainStyles();
    const classes = useStyles();
    const navigate = useNavigate();
    const { currentUser } = useContext(CorporateContext);

    const filterByUserIdOnlyMaintenanceOrOperator = useMemo(
        () =>
            currentUser?.user_type?.user_type_id === USERTYPE.OPERATIONS ||
            currentUser?.user_type?.user_type_id === USERTYPE.MAINTENANCE
                ? currentUser?.user_id
                : undefined,
        [currentUser],
    );
    const { handleRequestSort, handleChangeRowsPerPage, handleChangePage, order, orderBy, page, rowsPerPage } =
        useTableOperations();
    const queryTableOperationFilters = useMemo(
        () => ({
            order,
            orderBy,
            limit: rowsPerPage,
            offset: page * rowsPerPage,
        }),
        [order, orderBy, rowsPerPage, page],
    );
    const { loading, actionPlans, apolloQueryError, refetch, totalCount } =
        ActionPlanEntity.GetAllActionPlansForApproval(
            queryTableOperationFilters,
            filterByUserIdOnlyMaintenanceOrOperator,
        );
    const tableColumns = useMyActionPlansColumns({ refetch }) as unknown as IMainTableColumn[];

    return (
        <Card className={mainClasses.contentCard}>
            <div className={mainClasses.contentCardHeader}>
                <span className={mainClasses.contentCardTitleCapitalized}>
                    {t("rca.rca_dashboard.pending_approval.title")}
                </span>
            </div>
            <div className={mainClasses.contentCardContent}>
                {actionPlans && !actionPlans.length && (
                    <NoData className={mainClasses.contentNoData} title={t("data.no_data_short")} />
                )}
                {actionPlans && !!actionPlans.length && (
                    <MainTable
                        maxHeight={false}
                        customStyle={`${mainClasses.contentTable} ${classes.mainTable}`}
                        paperElevation={0}
                        paperCustomStyle={mainClasses.contentTablePaperMyDashboard}
                        columns={tableColumns}
                        customStyleTypography={{ width: "100%" }}
                        tableCellCustomStyle={mainClasses.contentTableCell}
                        rows={!loading && !apolloQueryError ? actionPlans : []}
                        loading={loading}
                        tableOperationsValues={{ order, orderBy, page, rowsPerPage }}
                        handleRequestSortParent={handleRequestSort}
                        querySorted={!!orderBy}
                        handleChangeRowsPerPageParent={handleChangeRowsPerPage}
                        handleChangePageParent={handleChangePage}
                        pagination
                        count={totalCount}
                        onRowClick={(row: { action_plan_id?: number }) => {
                            navigate(
                                `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_ACTION_PLANS.ROOT}/${row.action_plan_id}`,
                                {
                                    state: {
                                        from: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}`,
                                    },
                                },
                            );
                        }}
                    />
                )}
            </div>
        </Card>
    );
};

export default PendingApprovalActionPlan;
